export var CREATE_INTEGRATION_REQUEST = 'src/IntegrationNew/CREATE_INTEGRATION_REQUEST';
export var CREATE_INTEGRATION_SUCCESS = 'src/IntegrationNew/CREATE_INTEGRATION_SUCCESS';
export var CREATE_INTEGRATION_FAILURE = 'src/IntegrationNew/CREATE_INTEGRATION_FAILURE';
export var LOAD_INTEGRATION_REQUEST = 'src/IntegrationNew/LOAD_INTEGRATION_REQUEST';
export var LOAD_INTEGRATION_SUCCESS = 'src/IntegrationNew/LOAD_INTEGRATION_SUCCESS';
export var LOAD_INTEGRATION_FAILURE = 'src/IntegrationNew/LOAD_INTEGRATION_FAILURE';
export var UPDATE_INTEGRATION_REQUEST = 'src/IntegrationNew/UPDATE_INTEGRATION_REQUEST';
export var UPDATE_INTEGRATION_SUCCESS = 'src/IntegrationNew/UPDATE_INTEGRATION_SUCCESS';
export var UPDATE_INTEGRATION_FAILURE = 'src/IntegrationNew/UPDATE_INTEGRATION_FAILURE';
